import { Button } from "antd";
import Input from "antd/lib/input/Input";
import { useHistory } from "react-router-dom";
import { Locale } from "../../../utils";

const i18n = Locale.getInstance();
const EmployeeListHeader = ({ keyword, setKeyword }) => {
  const history = useHistory();
  return (
    <div className="header">
      <div className="actions">
        <Button
          onClick={() => {
            history.push({
              pathname: "/main/bd/employee/edit",
            });
          }}
          type="primary"
        >
          {i18n.t("bd.employee.add")}
        </Button>
      </div>
      <div className="search">
        <Input
          defaultValue={keyword}
          onChange={(e) => {
            setKeyword(e.target.value);
          }}
          placeholder={i18n.t("course.teacher.name")}
        />
        <Button type="primary">{i18n.t("common.search")}</Button>
      </div>
    </div>
  );
};
export default EmployeeListHeader;
